var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 11.56C1 6.58197 1 4.09296 2.54648 2.54648C4.09296 1 6.58197 1 11.56 1H12.44C17.418 1 19.907 1 21.4535 2.54648C23 4.09296 23 6.58197 23 11.56V12.44C23 17.418 23 19.907 21.4535 21.4535C19.907 23 17.418 23 12.44 23H11.56C6.58197 23 4.09296 23 2.54648 21.4535C1 19.907 1 17.418 1 12.44V11.56Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.706 16.8493C7.6918 16.8493 4.83182 13.4118 4.71265 7.69177H7.22432C7.30682 11.8901 9.15845 13.6684 10.6251 14.0351V7.69177H12.9902V11.3126C14.4385 11.1567 15.96 9.50677 16.4733 7.69177H18.8384C18.4442 9.92845 16.7942 11.5784 15.6209 12.2568C16.7942 12.8068 18.6735 14.2459 19.3885 16.8493H16.7851C16.2259 15.1076 14.8327 13.7601 12.9902 13.5768V16.8493H12.706Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/vk-icon.ded33f04ed80a3682b7f984bce2eef4f.svg";
export { ForwardRef as ReactComponent };